export default __webpack_public_path__ + "static/media/id.bdbcbb1d.svg";